/** The three kinds of catalogue item a brand can exclude from discounts, in the tab's order. */
export const EXCLUSION_KINDS = [
	{ key: 'productIds', label: 'Products', search: 'Search products' },
	{ key: 'tags', label: 'Tags', search: 'Search tags' },
	{ key: 'collectionIds', label: 'Collections', search: 'Search collections' }
] as const;
